import React from 'react';
import { Textarea } from '../form';
import { Button, Icon } from '../common';
import Icons from '@/const/icons';
import { FieldValues, UseFormReturn, SubmitHandler } from 'react-hook-form';
import clsx from 'clsx';

const rules = {
	message: {
		required: { value: true, message: 'This is required.' },
	},
};

interface Props {
	onSubmit: SubmitHandler<FieldValues>;
	form: UseFormReturn<FieldValues>;
	className?: string;
	disabled?: boolean;
	autoResize?: boolean;
}

export const InputSend: React.FC<Props> = ({
	disabled,
	form,
	onSubmit,
	className,
	autoResize = false,
}) => {
	const {
		register,
		handleSubmit,
		formState: { isValid, isSubmitting },
	} = form;
	const textAreaRef = React.useRef<HTMLTextAreaElement | null>(null);

	const handleSubmitWithReset: SubmitHandler<FieldValues> = async (data) => {
		await onSubmit(data);
		if (textAreaRef.current) textAreaRef.current.style.height = 'auto';
	};

	return (
		<form
			onSubmit={handleSubmit(handleSubmitWithReset)}
			className={clsx('shrink-0', className)}
		>
			<div className="flex items-end gap-2">
				<Textarea
					name="message"
					placeholder="Write your message here"
					register={register}
					className="w-full"
					classNameContainerInput="!rounded-[16px]"
					classNameInput={
						autoResize ? 'max-h-[120px] overflow-y-auto' : undefined
					}
					rows={autoResize ? 1 : undefined}
					autoResize={autoResize}
					textAreaRef={autoResize ? textAreaRef : undefined}
					rules={rules.message}
					disabled={disabled}
				/>
				<Button
					type="submit"
					disabled={!isValid || isSubmitting || disabled}
					decoration="primary"
					className="rounded-full !w-12 !h-12 !p-0 shrink-0 mb-1"
				>
					<Icon src={Icons.sendEmail} width={16} height={16} />
				</Button>
			</div>
		</form>
	);
};
